module.exports = __webpack_public_path__ + "img/headImg.a762c7d3.png";